import React, { useState } from "react"
import {Established} from './style'
import { useScrollPosition } from "shared/Hooks/useScrollPosition"

export const EST = ({ light,active }) => {
    const [blackOnScroll, setBlackOnScroll] = useState(false)
    const isBrowser = typeof window !== `undefined`
    let isTickets = false
 
    if(isBrowser) {
        isTickets = window.location.pathname === "/bilety"
    }
    useScrollPosition(({prevPos,currPos}) => {
        if(isBrowser) {
            if(currPos.y < (-window.innerHeight/2)-100 && window.location.pathname !== '/kontakt') {
                setBlackOnScroll(true)
            }else {
                setBlackOnScroll(false)
            }
        }
    }, [blackOnScroll], false, false, 1000)
    return(
    <Established light={light || blackOnScroll} tickets={isTickets} active={active}>
        EST. 1954
    </Established>

)}